import React from "react";
import { Box, Typography } from "@mui/material";
import { COLOR_CONSTANTS, TYPOGRAPHY_SCALE } from "../../constants/styles";
import { SPACING_CONSTANTS } from "../../constants/styles/spacing";

interface CompareSectionProps {
  /**
   * 첫 번째 비교 항목 번호
   */
  firstNumber?: number;
  /**
   * 두 번째 비교 항목 번호
   */
  secondNumber?: number;
  /**
   * 비교 라벨 텍스트
   */
  label?: string;
}

/**
 * 비교 섹션 컴포넌트
 * 피그마 디자인에 따라 숫자 배지와 화살표, 라벨을 표시합니다.
 */
export const CompareSection: React.FC<CompareSectionProps> = ({
  firstNumber = 1,
  secondNumber = 2,
  label = "비교",
}) => {
  return (
    <Box sx={{ 
      display: "flex", 
      alignItems: "center", 
      gap: `${SPACING_CONSTANTS.spacing[1]}px`, 
      marginRight: `${SPACING_CONSTANTS.spacing[4]}px`, 
    }}>
      {/* 첫 번째 숫자 배지 */}
      <Box sx={{
        width: "20px",
        height: "20px",
        borderRadius: "50%",
        backgroundColor: COLOR_CONSTANTS.COLOR.BLUE_GREY[300],
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}>
        <Typography sx={{
          ...TYPOGRAPHY_SCALE.caption1,
          color: "#ffffff",
          fontWeight: 500,
          fontSize: "12px",
          lineHeight: 1,
        }}>
          {firstNumber}
        </Typography>
      </Box>

      {/* 화살표 */}
      <Typography sx={{
        ...TYPOGRAPHY_SCALE.body2,
        color: "#555555",
        fontWeight: 500,
        fontSize: "14px",
        lineHeight: 1,
      }}>
        →
      </Typography>

      {/* 두 번째 숫자 배지 */}
      <Box sx={{
        width: "20px",
        height: "20px",
        borderRadius: "50%",
        backgroundColor: COLOR_CONSTANTS.COLOR.BLUE_GREY[300],
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}>
        <Typography sx={{
          ...TYPOGRAPHY_SCALE.caption1,
          color: "#ffffff",
          fontWeight: 500,
          fontSize: "12px",
          lineHeight: 1,
        }}>
          {secondNumber}
        </Typography>
      </Box>

      {/* 비교 라벨 */}
      <Typography sx={{
        ...TYPOGRAPHY_SCALE.body2,
        color: COLOR_CONSTANTS.text.primary,
        fontWeight: 500,
        fontSize: "14px",
        lineHeight: 1,
      }}>
        {label}
      </Typography>
    </Box>
  );
};

export type { CompareSectionProps };
